// import { Component, Vue, Prop } from 'vue-property-decorator'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import vSelect from 'vue-select'

import TypeableDatePortal from '@/components/edit/TypeableDatePortal/index.vue'
import MessageSuccess from '@/components/edit/MessageSuccess/index.vue'

import { Validations } from 'vuelidate-property-decorators'
import { required, minLength } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

import blackListCNPJ from './blackListCNPJ'

import fetch from '@/helpers/fetch'
import cnjParser from '@/helpers/cnjParser'
import Control from '@/helpers/control'

@Component({
	components: {
		Loader,
		vSelect,
		TypeableDatePortal,
		MessageSuccess,
	},
	mixins: [validationMixin],
})
export default class ResearchModal extends Vue {
	@Prop() fields!: any
	@Prop() title!: any
	@Prop() items!: any

	fieldsCreateOrder: any = null

	item: any | null = {}
	changedFields: object = {}

	mounted() {
		this.fieldsCreateOrder = [...this.fields]
			.filter((field) => {
				return field.createOrder
			})
			.sort((fieldA, fieldB) => {
				if (!fieldA.createOrder || !fieldB.createOrder) {
					return 1
				}

				if (fieldA.createOrder > fieldB.createOrder) {
					return 1
				}

				if (fieldA.createOrder < fieldB.createOrder) {
					return -1
				}

				return 0
			})
	}

	isOpeningModal = false
	async open(item) {
		this.isOpeningModal = true
		this.submitSuccess = false

		this.changedFields = {}

		this.item = item

		this.$v.item.$reset()

		this.$bvModal.show('pesquisa')

		if (this.item) {
			await Vue.nextTick()
			this.isOpeningModal = false
			this.$v.item.$reset()
		}
	}

	getVModel(field, item) {
		if (item) {
			return item[field.fieldName]
		}

		return field.create.model
	}

	@Validations()
	validations() {
		return {
			item: {
				company_name: {
					required,
				},
				company_group_name: {},
				research_date: {
					required,
				},
				cnpj: {
					required,
					minLength: minLength(18),
					validCNPJ,
					blockCNPJ,
				},
				multinational: {},
				publicly_traded: {},
				complete_research: {},
				market_sector: {
					required,
				},
				calc_subject: {
					required,
					alreadyExists: alreadyExists.bind(this),
				},
				cnj: {
					required,
					minLength: minLength(25),
					validaCNJ,
				},
				distribution_date: {
					required,
				},
				courthouse: {
					required,
				},
				state: {
					required,
				},
				city: {
					required,
				},
				law_firm: {
					required,
				},
			},
		}
	}

	submitLoading = false
	submitSuccess = false
	async submit() {
		this.submitSuccess = false

		this.$v.item.$touch()

		const invalid = this.$v.item.$invalid
		if (invalid || this.submitLoading) {
			return
		}

		this.submitLoading = true

		const newItem: any = {}
		const item: any = this.item

		this.fields.forEach((field) => {
			if (field.onDatabase) {
				const fieldName = field.fieldName

				if (
					!item.id ||
					(item.id &&
						Object.keys(this.changedFields).includes(fieldName))
				) {
					newItem[fieldName] = item[fieldName]

					if (field.unformat) {
						newItem[fieldName] = field.unformat(item[fieldName])
					} else {
						newItem[fieldName] = item[fieldName]
					}
				}
			}
		})

		let res

		if (newItem.company_name) {
			newItem.company_name = newItem.company_name.trim()
		}

		if (item.id) {
			newItem.id = item.id

			if (Object.keys(this.changedFields).length) {
				res = await fetch.post(
					'/api/thermometer/entry/' + item.id,
					newItem,
				)
			}
		} else {
			res = await fetch.post('/api/thermometer/entry', newItem)
		}

		this.submitLoading = false

		if (res && res.ok) {
			this.submitSuccess = true
			this.changedFields = {}
			this.$emit('insert')

			if (!item.id) {
				this.fieldsCreateOrder.forEach((field) => {
					const fieldName = field.fieldName
					if (field.clearAfterCreate) {
						// if (fieldName !== 'distribution_date') {
						item[fieldName] = null
						// }

						// else {
						// 	item[fieldName] = ''
						// }
					}
				})
			}
		}
	}

	control = new Control()
	debouncedFunctionByField = {}

	onCheckboxTriggerChange(field, event) {
		const fieldName = field.fieldName

		this.changedFields[fieldName] = true
	}

	onTriggerChange(field, event) {
		if (!this.isOpeningModal) {
			this.debouncedFunctionByField[field.fieldName] =
				this.debouncedFunctionByField[field.fieldName] ||
				this.control.debounce(this.onChange, 500)

			let value
			if (event) {
				if (event.target && event.target.value) {
					value = event.target.value
				} else {
					value = event
				}
			}

			const func = this.debouncedFunctionByField[field.fieldName]
			func(field, value)
		}
	}

	onChange(field, value) {
		const fieldName = field.fieldName

		this.changedFields[fieldName] = true

		if (field.type === 'date') {
			const vField = this.$v.item[fieldName]
			if (vField) {
				vField.$model = value
				vField.$touch()
			}
		}

		if (fieldName === 'company_name') {
			this.loadCNPJs(this.item.company_name)
		}

		if (fieldName === 'cnpj' && !this.item.company_name) {
			this.loadCompanies(value)
		}

		if (fieldName === 'cnj') {
			const vField = this.$v.item[fieldName]
			if (vField) {
				this.sugestionsFromCnj(vField.$model)
			}
		}

		if (fieldName === 'calc_subject') {
			const calcSubjectName = value.name

			// this.subjectsByCnj.find()
		}
	}

	getValidationItem(field): any {
		return this.$v.item[field.fieldName] || {}
	}

	researchModalKey = 0
	async loadCNPJs(company) {
		if (company) {
			const companyName = company.name

			if (companyName === null) return

			const found = this.fields.find(
				(field) => field.fieldName === 'cnpj',
			)

			found.loadingOptions = true

			const res = await fetch.get(
				'/api/thermometer/collections/distinct/cnpjs?company_name=' +
					encodeURIComponent(companyName),
			)

			if (res?.ok && res?.data?.length) {
				const showCNPJOptions = found.showCNPJOptions

				const options = res?.data?.map((item) => {
					return found.format(item)
				})

				found.type = showCNPJOptions.type
				found.options = options
				found.taggable = showCNPJOptions.taggable
			}

			found.loadingOptions = false

			await this.loadGroup(companyName, null)
		}
	}

	async loadCompanies(cnpj) {
		const found = this.fields.find((field) => field.fieldName === 'cnpj')
		const rawCnpj = found.unformat(cnpj)

		let res
		if (rawCnpj && rawCnpj.length) {
			res = await fetch.get(
				'/api/thermometer/collections/distinct/company?cnpj=' + rawCnpj,
			)
		}

		if (res && res?.ok && res?.data?.length) {
			const company = res.data[0]
			const marketSector = company.market_sector

			const foundField = this.fields.find(
				(field) => field.fieldName === 'company_name',
			)

			const options = foundField.options

			const foundOption = options.find((option) => {
				return option.name === company.company_name
			})

			if (foundOption) {
				this.item.company_name = foundOption

				if (marketSector) {
					this.item.market_sector = marketSector
				}
			}

			await this.loadGroup(null, rawCnpj)
		}
	}

	async loadGroup(companyName, rawCnpj) {
		let query = ''

		if (companyName) {
			query = `company_name=${encodeURIComponent(companyName)}`
		} else if (rawCnpj) {
			query = `cnpj=${rawCnpj}`
		}

		const res = await fetch.get(
			'/api/thermometer/collections/distinct/companies-groups?' + query,
		)

		if (res.ok) {
			if (res.data.length > 0) {
				this.item.company_group_name = { name: res.data[0] }
			}
		}
		this.researchModalKey++
	}

	getOptionKey(option) {
		let id = option.id || option.index
		if (!id) id = option
		return 'research-modal-option-' + id
	}

	onSearch(allItems, search) {
		if (typeof search !== 'string') return
		const searchArray = search?.split(' ')

		const result = allItems.filter((item) => {
			const name = removeAccents(item.name.toLowerCase())

			return searchArray.every((string) => {
				return name.includes(removeAccents(string.toLowerCase()))
			})
		})

		return result
	}

	getOptionDisplayName(option, field) {
		let value = option[field.vSelectLabel] || option

		// if (field.format) {
		// 	const formatted = field.format(value)
		// 	if (formatted) {
		// 		value = formatted
		// 	}
		// }

		return value
	}

	subjectAlreadyInCnj = false
	subjectsByCnj = {}
	async sugestionsFromCnj(cnj) {
		if (!validaCNJ(null, cnj)) return

		const data = await cnjParser.getData(cnj)
		if (!data) return

		const foundFields = {
			courthouse: true as any,
			state: true as any,
		}

		this.fields.forEach((field) => {
			const fieldName = field.fieldName
			if (foundFields[fieldName]) {
				foundFields[fieldName] = field
			}
		})

		const city = data.city
		this.item.city = city

		const courthouseOptions: any = foundFields.courthouse.options
		const foundCourthouse = courthouseOptions.find((option) => {
			const courthouse = data.courthouse
			return option.name === courthouse
		})

		if (foundCourthouse) {
			this.item.courthouse = foundCourthouse
		}

		const stateOptions = foundFields.state.options
		const foundState = stateOptions.find((option) => {
			const state = data.state
			return option.name === state
		})
		if (foundState) {
			this.item.state = foundState
		}

		const cnjOnlyNumbers = cnj.replace(/[.-]/g, '')

		const res = await fetch.get(
			'/api/thermometer/collections/by/cnj?cnj=' +
				encodeURIComponent(cnjOnlyNumbers),
		)

		const list = res.data
		this.subjectsByCnj[cnjOnlyNumbers] =
			this.subjectsByCnj[cnjOnlyNumbers] || []
		this.subjectsByCnj[cnjOnlyNumbers].push([...list])
	}
}

function removeAccents(str) {
	return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

function validaCNJ($event, number) {
	if (!number) return false
	if (number.cnj) number = number.cnj

	const numero = number.replace(/\./g, '').replace('-', '')

	if (numero.length !== 20) {
		return false
	}

	const bcmod = (x, y) => {
		const take = 5
		let mod: string | number = ''

		do {
			const a = parseInt(mod + x.substr(0, take))
			x = x.substr(take)
			mod = a % y
		} while (x.length)

		return mod
	}

	const numeroProcesso = numero.replace(/[.-]/g, '')

	if (
		numeroProcesso.length < 14 ||
		(typeof numeroProcesso === 'number' && isNaN(numeroProcesso))
	) {
		return false
	}

	const digitoVerificadorExtraido = parseInt(numeroProcesso.substr(-13, 2))

	const vara = numeroProcesso.substr(-4, 4)
	const tribunal = numeroProcesso.substr(-6, 2)
	const ramo = numeroProcesso.substr(-7, 1)
	const anoInicio = numeroProcesso.substr(-11, 4)
	const tamanho = numeroProcesso.length - 13
	const numeroSequencial = numeroProcesso.substr(0, tamanho).padStart(7, '0')

	const digitoVerificadorCalculado =
		98 -
		bcmod(
			numeroSequencial + anoInicio + ramo + tribunal + vara + '00',
			'97',
		)

	return digitoVerificadorExtraido === digitoVerificadorCalculado
}

// Método de validação
// Referência: https://pt.wikipedia.org/wiki/Cadastro_Nacional_da_Pessoa_Jur%C3%ADdica
function validCNPJ(value: string | number | number[] = '') {
	if (!value) return false

	// Aceita receber o valor como string, número ou array com todos os dígitos
	const isString = typeof value === 'string'
	const validTypes =
		isString || Number.isInteger(value) || Array.isArray(value)

	// Elimina valor de tipo inválido
	if (!validTypes) return false

	// Filtro inicial para entradas do tipo string
	if (isString && typeof value === 'string') {
		// Regex para validação de string no formato CNPJ
		const regexCNPJ = /^\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}$/
		const stringValue: string = value
		// Teste Regex para veificar se é uma string apenas dígitos válida
		const digitsOnly = /^\d{14}$/.test(stringValue)
		// Teste Regex para verificar se é uma string formatada válida
		const validFormat = regexCNPJ.test(stringValue)
		// Verifica se o valor passou em ao menos 1 dos testes
		const isValid = digitsOnly || validFormat

		// Se o formato não é válido, retorna inválido
		if (!isValid) return false
	}

	// Elimina tudo que não é dígito
	const numbers = matchNumbers(value)

	// Valida a quantidade de dígitos
	if (numbers.length !== 14) return false

	// Elimina inválidos com todos os dígitos iguais
	const items = [...new Set(numbers)]
	if (items.length === 1) return false

	// Separa os 2 últimos dígitos verificadores
	const digits = numbers.slice(12)

	// Valida 1o. dígito verificador
	const digit0 = validCalc(12, numbers)
	if (digit0 !== digits[0]) return false

	// Valida 2o. dígito verificador
	const digit1 = validCalc(13, numbers)
	return digit1 === digits[1]
}

// Cálculo validador
function validCalc(x: number, numbers: number[]) {
	const slice = numbers.slice(0, x)
	let factor = x - 7
	let sum = 0

	for (let i = x; i >= 1; i--) {
		const n = slice[x - i]
		sum += n * factor--
		if (factor < 2) factor = 9
	}

	const result = 11 - (sum % 11)

	return result > 9 ? 0 : result
}

// Elimina tudo que não é dígito
function matchNumbers(value: string | number | number[] = '') {
	const match = value.toString().match(/\d/g)
	return Array.isArray(match) ? match.map(Number) : []
}

function blockCNPJ(formattedCNPJ) {
	if (!formattedCNPJ || typeof formattedCNPJ !== 'string') return false

	const cnpj = formattedCNPJ ? formattedCNPJ?.replace(/[.\-/]/g, '') : ''
	const found = blackListCNPJ.find((blocked) => blocked.cnpj === cnpj)

	if (found) {
		return false
	}

	return true
}

function alreadyExists(subject) {
	const that: any = this
	const cnjOnlyNumbers = (that.item.cnj || '').replace(/[.-]/g, '')

	const list = this.subjectsByCnj[cnjOnlyNumbers]

	if (list && list.length) {
		const found = list.find((item) => {
			const subjectId = item?.[0]?.calc_subject?.id

			return subject.id === subjectId
		})

		if (found) {
			return false
		}
	}

	return true
}
